// extracted by css-extract-rspack-plugin
export default {"question":"_48a57be1","questionTitle":"_e1576341","button":"_889b4979"};